import React from "react";
import { IncludeHouseIcon } from "../../../../assets/assetExport";
import "./Info.scss";
import { useSelector } from "react-redux";
import { getLang } from "../../../../features/app/UserRelatedSlice";
import { getIsMobile } from "../../../../features/app/UIRelatedSlice";
import { renderNum } from "../../../../util/formatters";

export default function Info(props: any) {
  const {
    id,
    house,
    name,
    nameCN,
    zoneOther,
    zoneMain,
    postcode,
    borough,
    completion,
    bed0,
    bed1,
    bed2,
    bed3,
    bed4,
    bed5,
    bed6,
    station,
    distance,
  } = props.obj;
  const lang = useSelector(getLang);
  const isMobile = useSelector(getIsMobile);

  const imageId = `NV${String(id).padStart(4, "0").slice(-4)}.jpg`;
  const imgUrl = require("../../../../assets/media/developmentImages/" +
    imageId);

  const isFlexCol = props.view === "list" && isMobile;

  return (
    <>
      <img
        alt=""
        className={`
          ${
            props.customiseImg
              ? isMobile
                ? `${
                    props.view === "list" ? "w-auto" : "w-[100px]"
                  }  h-auto flex-grow object-cover rounded-l-lg`
                : "w-[100px] h-full object-cover rounded-l-lg"
              : "w-full grid-dev-img rounded-l-lg"
          }
          `}
        // className={`
        //   ${isMobile ? (props.customiseImg ? "w-[50px] h-auto flex-grow object-cover rounded-l-lg" : "") : (props.customiseImg
        //     ? "w-full h-40 object-cover rounded-t-lg"
        //     : "grid-dev-img rounded-l-lg")}`}
        src={imgUrl}
      />
      <div
        className={`info-dev-content text-[1rem] p-6 ${
          isMobile ? (props.view === "list" ? "p-3 w-[220px]" : "p-3") : "p-6"
        } text-sm`}
        // } text-sm ${props.view === "popup" ? "w-full" : ""}`}
      >
        <div
          className={`${
            ""
            // props.view === "popup" ? "flex-col gap-2" : ""
          } flex justify-between items-start border-b border-[#3c006b] pb-3 mb-2`}
        >
          {/* Title */}
          <div>
            <h3 className="m-0 text-[#3c006b] text-[18px] leading-[1.1] font-bold flex items-center gap-2">
              {name}
              {house && <IncludeHouseIcon width="18" height="18" />}
            </h3>
            {/* NameCN (hidden in EN only) */}
            {!lang && (
              <p className="text-base font-normal text-gray-600 m-0">
                <span>{nameCN}</span>
              </p>
            )}
          </div>
          {/* Completion Status */}
          <span
            className="
            text-[11px] text-[#666] font-semibold bg-[#f4f4f4] px-2 py-[2px] 
            rounded whitespace-nowrap
          "
          >
            {lang
              ? completion
              : completion === "Completed"
              ? "现房"
              : completion}
          </span>
        </div>
        <div className={`flex pt-3`}>
          {/* Column 1: Prices */}
          <div
            className={`${
              props.view === "popup"
                ? "w-auto border-b pb-2"
                : " w-[45%] border-r pr-2"
            }  border-[#eee]  text-[11px] text-[#333]`}
          >
            <strong className="block text-[9px] text-[#999] mb-[5px] uppercase tracking-[0.5px]">
              {lang ? "Pricing" : "价格"}
            </strong>

            {/* Price Lines (Studio-6Bed) */}
            {(() => {
              let items = [];
              // Language-specific labels
              const bedLabels = lang
                ? [
                    "Studio",
                    "1 Bed",
                    "2 Bed",
                    "3 Bed",
                    "4 Bed",
                    "5 Bed",
                    "6 Bed",
                  ]
                : ["开间", "一室", "两室", "三室", "四室", "五室", "六室"];
              const beds = [bed0, bed1, bed2, bed3, bed4, bed5, bed6];

              for (let i = 0; i < beds.length; ++i) {
                if (beds[i]) {
                  items.push(
                    <div className="flex  mb-[3px] last:mb-0" key={i}>
                      <span className="text-[#666]">
                        {bedLabels[i]}
                        {lang ? ":" : "："}
                      </span>
                      {lang ? <span>&nbsp;</span> : null}
                      <span className="font-semibold">
                        {renderNum(beds[i])}
                      </span>
                    </div>
                  );
                }
              }

              if (items.length === 0) {
                items.push(
                  <div
                    className="flex justify-between mb-[3px] last:mb-0"
                    key="tbc"
                  >
                    <span className="text-[#666]">{lang ? "TBC" : "待定"}</span>
                    <span className="font-semibold"></span>
                  </div>
                );
              }

              return items;
            })()}
          </div>

          {/* Column 2: Location/Info */}
          <div
            className={`${
              props.view === "popup" ? "w-auto " : "w-[55%] pl-3"
            }  text-[11px] text-[#333] flex flex-col`}
          >
            <strong className="block text-[9px] text-[#999] mb-[5px] uppercase tracking-[0.5px]">
              {lang ? "Location" : "地理位置"}
            </strong>
            {/* Zone + Postcode */}
            <div className="mb-[3px] flex items-center">
              <span className="font-bold text-[#3c006b]">
                {lang ? "Zone " : "地铁区"}
                {zoneMain <= 6 ? zoneMain : "N/A"}
                {zoneOther && zoneOther <= 6 && ` / ${zoneOther}`}
              </span>
              <span className="text-[#eee] mx-[3px]">&nbsp;|&nbsp;</span>
              <span>{postcode ? postcode : "N/A"}</span>
            </div>
            {/* Borough */}
            <div className="mt-2">
              <span className="text-[#999] text-[9px] block mb-[1px]">
                {lang ? "Borough:" : "区域："}
              </span>
              <span className="font-medium">{borough}</span>
            </div>
            {/* Station & Distance */}
            <div className="mt-2">
              <span className="text-[#999] text-[9px] block mb-[1px]">
                {lang ? "Station:" : "最近车站："}
              </span>
              <span className="font-medium">
                {station} {distance ? `(${distance}km)` : ""}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
